import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-submit-button',
  templateUrl: './submit-button.component.html',
  styles: [`
    .button-spinner {
      margin-right: 8px;
      display: inline-block;
      vertical-align: middle;
    }
    .button-content {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .small-icon {
      font-size: 18px;
      height: 18px;
      width: 18px;
      margin-right: 8px;
    }
  `]
})
export class SubmitButtonComponent implements OnInit {
  /**
   * Texto a mostrar en el botón. Por defecto 'Save'.
   */
  @Input() title: string = 'Save';

  /**
   * Icono de Material a mostrar. Por defecto 'save'.
   */
  @Input() icon: string = 'save';

  /**
   * Indica si se está realizando una acción de guardado. 
   * Deshabilita el botón y muestra un spinner.
   */
  @Input() saving: boolean = false;

  /**
   * Otras condiciones para deshabilitar el botón (ej. form.invalid).
   */
  @Input() disabled: boolean = false;

  /**
   * Clases CSS adicionales para el botón.
   */
  @Input() buttonClass: string = '';

  /**
   * Color de Material para el botón. Por defecto 'primary'.
   */
  @Input() color: string = 'primary';

  /**
   * Tipo de botón. Por defecto 'submit'.
   */
  @Input() type: string = 'submit';

  /**
   * Define si el botón es de estilo 'stroked' (con borde) o 'raised' (con relieve).
   * Por defecto false (raised).
   */
  @Input() isStroked: boolean = false;

  constructor() {}

  ngOnInit(): void {}
}
